import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { Goals } from "../../../Pages/DashboardUserStudent/Performancechatandcard";

export const ListDailygoalsSlice = createSlice({
  name: "ListDailygoalsSlice",
  initialState: {} as IReduxState<Goals>,
  reducers: {
    listDailygoals: (state) => {
      state.isLoading = true;
    },
    successlistDailygoals: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistDailygoals: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { failurelistDailygoals, listDailygoals, successlistDailygoals } =
  ListDailygoalsSlice.actions;

export default ListDailygoalsSlice.reducer;
